import { CheckoutData, Offer } from 'merchant-api/types';
import { Row, Col, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { codToCents } from '../OfferReview/codToCents';
import { Card, TripleGreenCheck } from '@odmonorepo/core-components';
import {
  Tooltip,
  FormattedMessageDiv,
  FormattedNumberDiv,
} from '@odmonorepo/core-components';
import { LOCCostsAndFees } from './LOCCostsAndFees';
import { LOCDetails } from './LOCDetails';
import { LOCSelectedDrawDetails } from './LOCSelectedDrawDetails';
import { PartnerNameCard } from './PartnerNameCard';

interface LocOfferProps {
  offer: Offer;
  checkout?: CheckoutData;
  partnerName?: string;
}

const LocOfferCard = ({ offer, checkout, partnerName }: LocOfferProps) => {
  const intl = useIntl();
  return (
    <Card
      data-testid="term-loan-container"
      style={{ maxWidth: '600px', margin: 'auto', width: '100%' }}
      bodyClassName="p-md-6 px-md-8 p-5"
    >
      <Stack gap={5}>
        <Row className="p-3 pb-0">
          <Col>
            <Row>
              <FormattedNumberDiv
                className="h1 mb-0 text-center"
                value={offer.pricedDetails.lineAmount}
                style={'currency'}
                currency="USD"
                minimumFractionDigits={0}
              />
            </Row>
            <Row className="mt-2">
              <FormattedMessageDiv
                className="fw-bold text-center"
                id="offerReview.locApprovedCreditLimit"
              />
            </Row>
          </Col>
        </Row>
        <PartnerNameCard partnerName={partnerName} />
        <LOCDetails offer={offer} />
        <LOCCostsAndFees offer={offer} checkout={checkout}/>
        {checkout ? (
          <LOCSelectedDrawDetails offer={offer} checkout={checkout} />
        ) : (
          <div>
            <TripleGreenCheck
              text3={intl.formatMessage({ id: 'offerReview.fastFunding' })}
              text2={intl.formatMessage({ id: 'offerReview.drawInterest' })}
              text1={intl.formatMessage({ id: 'offerReview.creditHistory' })}
            />
          </div>
        )}
      </Stack>
    </Card>
  );
};

export default LocOfferCard;
